import { FlexRow, LoaderBar, PrimaryEditButton, ScreenHeader } from 'components'
import { GetRoundDetailsById } from 'hooks'
import React, { useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  RoundUploadedVideoList,
  LeaderboardList,
  StatusBox,
  RoundInstructionList,
} from 'page-components'
import { CompetitionRoundDetailsTabs, DateUtility } from 'utility'
import { Tabs } from 'antd'
import { HeaderWrapper } from 'screens/dashboard'
import { PencilSimpleLine } from 'phosphor-react'
import styled from 'styled-components'

const Label = styled.span`
  font-weight: 500;
  color: #4c4c4c;
  font-weight: 400;
  margin-right: 4px;
`

export const RoundDetailScreen = () => {
  const [tab, setTab] = useState(CompetitionRoundDetailsTabs.Rounds)
  const { round, competitionId } = useParams()
  const location = useLocation()
  const { competitionName } = location.state || {}
  const { data, loading } = GetRoundDetailsById(competitionId, round)
  const navigate = useNavigate()

  const items = useMemo(
    () => [
      {
        key: CompetitionRoundDetailsTabs.Instructions,
        label: 'Instructions',
        children: <RoundInstructionList instruction={data?.instruction} />,
      },
      {
        key: CompetitionRoundDetailsTabs.Leaderboard,
        label: 'Leaderboard',
        children: (
          <LeaderboardList
            competitionName={competitionName}
            winnerSelected={data?.winnerSelected}
          />
        ),
      },
      {
        key: CompetitionRoundDetailsTabs.UploadedVideos,
        label: 'Uploaded Videos',
        children: <RoundUploadedVideoList />,
      },
    ],
    [data],
  )

  return (
    <div>
      <div>
        <HeaderWrapper>
          <ScreenHeader
            text={
              <FlexRow>
                <span className="me-3">{data?.name}</span>
                <StatusBox competition={data?.status} />
              </FlexRow>
            }
          />
          <PrimaryEditButton
            className=""
            onClick={() =>
              navigate(`/app/competitions/add-edit/${competitionId}`)
            }
          >
            <PencilSimpleLine size={20} color="#2454ff" />
            Edit
          </PrimaryEditButton>
        </HeaderWrapper>
      </div>
      {loading && <LoaderBar />}
      <div className="px-5 my-4 mt-3">
        <FlexRow>
          <Label>Total Winners:</Label>
          <strong className="ms-1">{data?.no_of_winners}</strong>
        </FlexRow>
        <FlexRow className="mt-1">
          <Label>Video submission deadline :</Label>
          <strong className="ms-1">
            {' '}
            {DateUtility.formatDate(new Date(data?.submission_deadline))}
          </strong>
        </FlexRow>
        <FlexRow className="mt-1">
          <Label> Voting deadline :</Label>
          <strong className="ms-1">
            {' '}
            {DateUtility.formatDate(new Date(data?.voting_deadline))}
          </strong>
        </FlexRow>
        <FlexRow className="mt-1">
          <Label> Result Announcement :</Label>
          <strong className="ms-1">
            {' '}
            {DateUtility.formatDate(new Date(data?.result_announcement))}
          </strong>
        </FlexRow>
      </div>
      <div className="px-5">
        <div className="tabs-container">
          <Tabs
            defaultActiveKey="1"
            activeKey={tab}
            items={items}
            className="custom-tabs"
            centered
            onChange={key => setTab(key)}
          />
        </div>
      </div>
    </div>
  )
}
